export default __webpack_public_path__ + "fonts/iconfont.9f4e7c1ebb74fd05c649d85dc6bcbf9e.woff2";